const ordinal = (number) => {
  const i = Math.floor(Math.abs(number));
  const i_mod_100 = i % 100;

  if (i_mod_100 === 11 || i_mod_100 === 12 || i_mod_100 === 13) {
    return 'th';
  }

  switch (i % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};

const ordinalize = (number) => `${number}${ordinal(number)}`;

const sequence = (i, j) => {
  return [...Array(j - i + 1).keys()].map(v => v + i);
};

export {ordinal, ordinalize, sequence};
